var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorpage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1519.41 1350.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6a6ace;}.cls-2{fill:#6baced;}.cls-3{fill:#8ec3ef;}.cls-4{fill:#37498c;}.cls-5{fill:#242850;}.cls-6{fill:#2a2f49;}.cls-7{fill:#2b3871;}.cls-8{fill:none;stroke:#3887e5;stroke-miterlimit:10;stroke-width:12px;}.cls-9{fill:#4757a1;}.cls-10{fill:#ff8164;}.cls-11{fill:#e0604b;}.cls-12{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1368.42,119.73C1276.12,7.55,1115-39.92,989.33,39.33,871.07,113.91,818.16,260,711.27,348.24c-112.07,92.54-235.44,97.4-371.13,80.88-117-14.24-250.07-12-296.29,124.24C-6.26,701.1,67.69,875,157.19,988.86a603.26,603.26,0,0,0,347,216.95c270.32,58.7,588.85-39.47,781.44-248C1484.68,742.18,1569.63,364.28,1368.42,119.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1380.64,
    cy: 1161.59,
    r: 105.1,
    transform: "translate(-416.99 1316.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129,547.41a254.14,254.14,0,0,1-40.65-31.22,4.22,4.22,0,0,0-5.79,6.14,262.8,262.8,0,0,0,42,32.25,4.18,4.18,0,0,0,2.45.62,4.1,4.1,0,0,0,1.48-.35,4.24,4.24,0,0,0,1.87-1.64,4.21,4.21,0,0,0-1.37-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.41,585.53a256.52,256.52,0,0,1-50.82-6.78,4.21,4.21,0,0,0-2,8.2,265.22,265.22,0,0,0,52.5,7h.38a4.39,4.39,0,0,0,1.46-.35,4.28,4.28,0,0,0,2.51-3.72A4.22,4.22,0,0,0,255.41,585.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.47,86.14h0a4.21,4.21,0,0,0,2.32-5.07,4.21,4.21,0,0,0-5.25-2.82,264.26,264.26,0,0,0-30.76,11.41c-6,2.67-12,5.6-17.81,8.71l-.33.18a4.21,4.21,0,0,0,2.24,7.91,4.29,4.29,0,0,0,1.75-.48l.32-.18c5.63-3,11.43-5.85,17.25-8.43A255.41,255.41,0,0,1,190,86.32C190.15,86.27,190.31,86.2,190.47,86.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.68,155.7a4.22,4.22,0,1,0-6.13-5.79,262.9,262.9,0,0,0-32.24,42,4.21,4.21,0,0,0,5.3,6.06h0a4.19,4.19,0,0,0,1.88-1.63A253.81,253.81,0,0,1,77.68,155.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.43,322.76a255.66,255.66,0,0,1,6.76-50.82,4.23,4.23,0,0,0-3.13-5.07A4.22,4.22,0,0,0,7,270a265,265,0,0,0-7,52.5,4.22,4.22,0,0,0,4.08,4.34c.13,0,.26,0,.38,0a4.07,4.07,0,0,0,1.46-.36A4.22,4.22,0,0,0,8.43,322.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.57,451c-3-5.63-5.85-11.43-8.43-17.25a255.48,255.48,0,0,1-11.09-29.89A4.21,4.21,0,1,0,11,406.3a264.48,264.48,0,0,0,11.45,30.88c2.67,6,5.6,12,8.71,17.81l.12.22a4.23,4.23,0,0,0,4,2.22,4.18,4.18,0,0,0,1.46-.36l.29-.14a4.23,4.23,0,0,0,1.72-5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.11,82.5a4.23,4.23,0,0,0,1.47-.36,4.22,4.22,0,0,0-.74-8,265.14,265.14,0,0,0-52.5-7,4.22,4.22,0,1,0-.26,8.43,255.81,255.81,0,0,1,50.82,6.73A4.51,4.51,0,0,0,323.11,82.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.78,555.39c-5.64,3-11.44,5.85-17.25,8.43a255.19,255.19,0,0,1-30,11.13,4.22,4.22,0,0,0-2.81,5.25,4.14,4.14,0,0,0,2,2.49,4.05,4.05,0,0,0,2.22.5,4.28,4.28,0,0,0,1-.17,264.7,264.7,0,0,0,31-11.49c6-2.66,12-5.59,17.78-8.69l.15-.08a4.15,4.15,0,0,0,1.66-5.68A4.27,4.27,0,0,0,383.78,555.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M522.64,334.6a4.23,4.23,0,0,0-4.35,4.07,255.71,255.71,0,0,1-6.8,50.82,4.19,4.19,0,0,0,4.34,5.18,4,4,0,0,0,1.47-.35,4.2,4.2,0,0,0,2.39-2.88,264.31,264.31,0,0,0,7-52.49A4.21,4.21,0,0,0,522.64,334.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M509.79,260.06a4.25,4.25,0,0,0,2.23.5,4.91,4.91,0,0,0,1-.17l.5-.19h0a4.22,4.22,0,0,0,2.32-5.06A264.35,264.35,0,0,0,504.3,224c-2.66-6-5.59-12-8.71-17.8l-.24-.45a4.22,4.22,0,0,0-7.43,4l.24.43c3,5.64,5.85,11.44,8.43,17.25a255.22,255.22,0,0,1,11.16,30.13A4.17,4.17,0,0,0,509.79,260.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M438.18,144.83A4.2,4.2,0,0,0,441.3,146a4.12,4.12,0,0,0,1.48-.36h0a4,4,0,0,0,1.35-1,4.21,4.21,0,0,0-.18-6,262.14,262.14,0,0,0-42-32.21,4.21,4.21,0,1,0-4.43,7.17A254.8,254.8,0,0,1,438.18,144.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M485.92,463.67a4.24,4.24,0,0,0-5.81,1.36,253.23,253.23,0,0,1-31.23,40.64,4.22,4.22,0,0,0,3.3,7.11,4.34,4.34,0,0,0,1.48-.36h0a4.27,4.27,0,0,0,1.35-1,261.74,261.74,0,0,0,32.27-42A4.22,4.22,0,0,0,485.92,463.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1346.7,1043.61a20,20,0,1,1,20-20A20.05,20.05,0,0,1,1346.7,1043.61Zm0-31.84a11.81,11.81,0,1,0,11.82,11.81A11.83,11.83,0,0,0,1346.7,1011.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119,1035.79h-12.3v-17.34a3.49,3.49,0,0,0-7,0v17.34H87.43a3.49,3.49,0,0,0,0,7h12.3v17.34a3.49,3.49,0,1,0,7,0v-17.34H119a3.49,3.49,0,0,0,0-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1320.19,188.76h-18.46v-26a5.24,5.24,0,0,0-10.48,0v26h-18.46a5.24,5.24,0,0,0,0,10.48h18.46v26a5.24,5.24,0,0,0,10.48,0v-26h18.46a5.24,5.24,0,0,0,0-10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M824,496a457.14,457.14,0,0,0-40.1,26.87,3.92,3.92,0,0,0,2.5,7l.39,0a4,4,0,0,0,1.81-.74A448.89,448.89,0,0,1,828,502.71a3.9,3.9,0,0,0,1.8-2.4A3.92,3.92,0,0,0,824,496Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M809.5,1267a454.87,454.87,0,0,1-38.09-28.27,3.89,3.89,0,0,0-2.87-.88,3.91,3.91,0,0,0-2.12,6.92,461.85,461.85,0,0,0,38.75,28.76,3.9,3.9,0,0,0,2.31.65l.39,0a3.88,3.88,0,0,0,2.73-1.71A3.92,3.92,0,0,0,809.5,1267Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M942.2,447.53a3.91,3.91,0,0,0-3-.38c-5.23,1.43-10.52,3-15.73,4.58-10.14,3.14-20.27,6.67-30.13,10.48a3.92,3.92,0,0,0,1.56,7.57l.4,0h0a4.29,4.29,0,0,0,.87-.23c9.69-3.75,19.65-7.21,29.62-10.3,5.11-1.59,10.32-3.1,15.47-4.51A3.92,3.92,0,0,0,944,449.9,3.87,3.87,0,0,0,942.2,447.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M920.29,1320.59a453.88,453.88,0,0,1-44.3-17,3.91,3.91,0,0,0-5.17,2,3.86,3.86,0,0,0-.08,3,3.9,3.9,0,0,0,2.06,2.18,464.4,464.4,0,0,0,45.06,17.31,4.22,4.22,0,0,0,1.36.19l.39,0a3.92,3.92,0,0,0,.68-7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M729,573a3.87,3.87,0,0,0-2.74,1.22A462.63,462.63,0,0,0,695,610.89a3.92,3.92,0,0,0,3.26,6.3l.39,0h0a3.85,3.85,0,0,0,2.57-1.5A454.78,454.78,0,0,1,732,579.57a3.93,3.93,0,0,0-3-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M658.61,674.22a4,4,0,0,0-3-.28,3.9,3.9,0,0,0-2.31,1.92A464.44,464.44,0,0,0,633,719.65a3.92,3.92,0,0,0,3.79,5.37l.39,0h0a3.93,3.93,0,0,0,3.1-2.42,456.06,456.06,0,0,1,20-43.05,3.87,3.87,0,0,0,.28-3A3.94,3.94,0,0,0,658.61,674.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M612,952.39c-1.59-11.45-2.75-23.1-3.45-34.63a3.91,3.91,0,0,0-4.12-3.67,3.84,3.84,0,0,0-2.7,1.27,4,4,0,0,0-1,2.88c.71,11.72,1.89,23.58,3.51,35.23.59,4.23,1.24,8.51,1.95,12.73a3.89,3.89,0,0,0,4,3.26,2.69,2.69,0,0,0,.4,0h0l.1,0a3.92,3.92,0,0,0,3.22-4.51C613.19,960.75,612.55,956.55,612,952.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M617.45,792.13a3.87,3.87,0,0,0-2.46-1.71,3.93,3.93,0,0,0-4.66,3,458.24,458.24,0,0,0-7.77,47.65,3.92,3.92,0,0,0,3.47,4.32,3.79,3.79,0,0,0,.58,0l.39,0h0a3.91,3.91,0,0,0,3.35-3.46A453.31,453.31,0,0,1,618,795.08,3.84,3.84,0,0,0,617.45,792.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1041.4,1342.33a448.53,448.53,0,0,1-47.25-4.42,3.92,3.92,0,0,0-1.14,7.76,461.24,461.24,0,0,0,48.07,4.5h.31l.39,0h0a3.92,3.92,0,0,0-.39-7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M688.18,1148.19a3.92,3.92,0,1,0-6.44,4.46,455.51,455.51,0,0,0,29.54,38.17,3.93,3.93,0,0,0,3.11,1.36l.4,0a3.89,3.89,0,0,0,2-.91,3.93,3.93,0,0,0,.41-5.53A446.22,446.22,0,0,1,688.18,1148.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M632.63,1038.43a3.92,3.92,0,1,0-7.41,2.56,462.06,462.06,0,0,0,18.1,44.73A3.88,3.88,0,0,0,647,1088l.4,0a3.79,3.79,0,0,0,1.12-.33,3.93,3.93,0,0,0,1.89-5.21A456.23,456.23,0,0,1,632.63,1038.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1377.11,1212.38a452.18,452.18,0,0,1-35.43,31.51,3.92,3.92,0,0,0,2.6,7l.39,0a3.86,3.86,0,0,0,1.9-.82,458.26,458.26,0,0,0,36-32.06,3.92,3.92,0,1,0-5.51-5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1469.46,682.46a457.42,457.42,0,0,0-24.06-41.85,3.92,3.92,0,0,0-5.42-1.15,3.85,3.85,0,0,0-1.7,2.47,3.93,3.93,0,0,0,.54,3A447.57,447.57,0,0,1,1462.47,686a3.94,3.94,0,0,0,3.65,2.15l.39,0h0a3.84,3.84,0,0,0,1.23-.39A3.91,3.91,0,0,0,1469.46,682.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1502.72,997.78a3.93,3.93,0,0,0-4.76,2.85,455.73,455.73,0,0,1-14,45.35,3.93,3.93,0,0,0,2.33,5,4,4,0,0,0,1.5.23l.39,0h0a3.9,3.9,0,0,0,3.14-2.54,463.48,463.48,0,0,0,14.22-46.13,3.93,3.93,0,0,0-2.84-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1515.2,874.29h0a3.93,3.93,0,0,0-3.78,4,452.57,452.57,0,0,1-1.18,47.45,3.92,3.92,0,0,0,3.6,4.21,2.37,2.37,0,0,0,.46,0l.39,0a4,4,0,0,0,3.36-3.58,457.46,457.46,0,0,0,1.2-48.28A3.92,3.92,0,0,0,1515.2,874.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1063.38,431a456.84,456.84,0,0,0-48.23,2.17,3.88,3.88,0,0,0-2.65,1.39,3.93,3.93,0,0,0,3.17,6.43l.23,0a449.9,449.9,0,0,1,47.42-2.13,3.64,3.64,0,0,0,.57,0h0a3.92,3.92,0,0,0-.51-7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1507.25,806.05h0l.22,0a3.93,3.93,0,0,0,3.08-4.61,468.71,468.71,0,0,0-11.89-46.79l-.21-.65a3.92,3.92,0,1,0-7.48,2.32l.2.65a456.37,456.37,0,0,1,11.69,46,3.93,3.93,0,0,0,4,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1457.35,1113.32a3.92,3.92,0,0,0-5.34,1.46,459.49,459.49,0,0,1-25.63,39.92,3.91,3.91,0,0,0,3.32,6.2,2.69,2.69,0,0,0,.4,0,3.92,3.92,0,0,0,2.64-1.6,463,463,0,0,0,26.08-40.61,3.92,3.92,0,0,0-1.47-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1363.64,545.9a3.92,3.92,0,1,0-5.18,5.89,453.33,453.33,0,0,1,33.91,33.15,3.89,3.89,0,0,0,3,1.26,2.56,2.56,0,0,0,.39,0h0a3.92,3.92,0,0,0,3.37-3.72,3.86,3.86,0,0,0-1-2.82A461.35,461.35,0,0,0,1363.64,545.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1163.87,1330.41a455.38,455.38,0,0,1-46.71,8.57,3.92,3.92,0,0,0,.68,7.8l.36,0,4.14-.56c14.48-2,29.06-4.76,43.34-8.16a3.91,3.91,0,0,0,2.91-4.71A3.93,3.93,0,0,0,1163.87,1330.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1187.25,449.12a460.4,460.4,0,0,0-47-11,4,4,0,0,0-2.93.64,3.92,3.92,0,0,0,1.55,7.08,453.3,453.3,0,0,1,46.21,10.8,3.7,3.7,0,0,0,1.24.15,2.56,2.56,0,0,0,.39,0,3.92,3.92,0,0,0,3.22-2.79,3.93,3.93,0,0,0-2.67-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1301.63,500a462.92,462.92,0,0,0-42.31-23.22,3.92,3.92,0,0,0-5.41,4.82,3.91,3.91,0,0,0,2,2.24,455.87,455.87,0,0,1,41.6,22.82,3.91,3.91,0,0,0,2.21.59l.39,0h0a3.92,3.92,0,0,0,1.52-7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1278.64,1286.06a455,455,0,0,1-42.67,20.73,3.91,3.91,0,0,0,1.67,7.52l.39,0h0a4.27,4.27,0,0,0,1-.27,463.37,463.37,0,0,0,43.41-21.09,3.92,3.92,0,0,0-3.79-6.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 729.6,
    y: 654.6,
    width: 53.19,
    height: 535.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 729.39,
    y: 654.8,
    width: 53.4,
    height: 18.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1067.6 221.74 1067.6 476.8 887.24 657.16 632.17 657.16 451.82 476.8 451.82 221.74 632.17 41.38 887.24 41.38 1067.6 221.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1067.59,349.27s-86.7,322-435.42,307.89H887.24L1067.59,476.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1037.67 234.13 1037.67 464.4 874.84 627.23 644.57 627.23 481.74 464.4 481.74 234.13 644.57 71.3 874.84 71.3 1037.67 234.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 761.44,
    y: 654.6,
    width: 21.36,
    height: 535.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 349.25,
    y: 1188.25,
    width: 812.12,
    height: 19.76,
    rx: 9.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M373.88,1208H245.8a9.89,9.89,0,0,1-9.88-9.88h0a9.89,9.89,0,0,1,9.88-9.89H373.88a9.88,9.88,0,0,1,9.88,9.89h0A9.88,9.88,0,0,1,373.88,1208Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 42.21,
    y: 1188.25,
    width: 154.34,
    height: 19.76,
    rx: 9.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1202.31,
    y: 1188.25,
    width: 130.18,
    height: 19.76,
    rx: 9.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1467.32,1208H1383.4a9.88,9.88,0,0,1-9.88-9.88h0a9.88,9.88,0,0,1,9.88-9.89h83.92a9.88,9.88,0,0,1,9.88,9.89h0A9.88,9.88,0,0,1,1467.32,1208Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "651.4 1150.69 371.59 1150.69 376.68 1132.26 386.62 1096.27 392.64 1074.47 401.52 1042.35 418.63 980.41 427.51 948.28 489.91 722.4 533.08 722.4 555.95 805.18 595.48 948.28 604.36 980.41 621.47 1042.35 630.35 1074.47 646.32 1132.26 651.4 1150.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 314.34,
    y: 1150.69,
    width: 394.32,
    height: 37.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "651.4 1150.69 371.59 1150.69 376.68 1132.26 646.32 1132.26 651.4 1150.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "604.36 980.41 418.63 980.41 427.51 948.28 595.48 948.28 604.36 980.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "630.35 1074.47 392.64 1074.47 401.52 1042.35 621.47 1042.35 630.35 1074.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M663.71,399.9c.95-8.73,5.58-15.9,9.85-23.23q5.41-9.3,10.78-18.64Q707,318.87,729.57,279.7c5.49-9.53,13.4-15.53,24.29-17.66,12.36-2.41,26.92,3.24,33.55,13.91,6.79,10.92,13.08,22.15,19.52,33.27q19.62,33.88,39.16,67.79c4.18,7.23,8.74,14.28,9.62,22.89v5.63c-1,3.59-1.49,7.4-3,10.74-6.36,13.76-17.33,20.66-32.5,20.75-10,.06-20,0-30,0q-45.74,0-91.47,0c-15.82,0-28.17-8.81-33.23-23.71-.81-2.39-1.2-4.94-1.78-7.41Zm95.81,21.65q30.27,0,60.54,0c4.9,0,9.41-1.13,13.22-4.36,7.42-6.3,8.93-15.92,3.87-24.69q-27.37-47.44-54.76-94.86c-2.44-4.22-4.71-8.54-7.43-12.57-4-5.92-9.8-8.54-16.91-7.95-6.93.57-11.69,4.37-15.1,10.29q-30.19,52.41-60.48,104.75A29,29,0,0,0,681,395a18.08,18.08,0,0,0,1.19,17.88c3.85,6.15,9.69,8.7,16.81,8.7Q729.25,421.53,759.52,421.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M769.44,327.63c-.75,13-1.51,26.06-2.27,39.15a45.24,45.24,0,0,1-.37,5.59,7.19,7.19,0,0,1-7.13,5.74,6.89,6.89,0,0,1-7.1-5.93c-.58-5-.76-10.08-1.07-15.12-.62-9.9-1.17-19.81-1.84-29.71-.48-7.18,4.72-12.71,11.32-11.9a9.72,9.72,0,0,1,8.45,8.9C769.51,325.4,769.44,326.47,769.44,327.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M759.75,404.54a9.83,9.83,0,0,1-.1-19.65,9.83,9.83,0,0,1,.1,19.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorpage);
export default __webpack_public_path__ + "static/media/errorpage.aa5fcd145ae8a0dcb733f58253cac87a.svg";
export { ForwardRef as ReactComponent };